<template>
  <div class="compound public-content" ref="collWrapper">
    <div class="breadcrumb">{{ title }}管理</div>
    <el-form :inline="true" :model="form" ref="searchForm" label-width="75px" style="margin:10px 0 10px 20px" class="demo-form-inline">
      <el-row>
        <el-col :span="5.5">
          <el-form-item :label="title + '名称'">
            <el-input v-model="form.taskName" :placeholder="`请输入${title}名称`" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="title + '状态'">
            <el-select clearable v-model="form.taskStatus" filterable placeholder="请选择">
              <el-option label="进行中" value="IN_PROGRESS"></el-option>
              <el-option :label="title + '完成'" value="END"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台名称:">
            <el-select clearable v-model="form.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
              <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7.5">
          <el-form-item label="开始日期" class="el-date-width">
            <el-date-picker v-model="value2" type="daterange" align="left" value-format="yyyy-MM-dd" format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="起始日期"
              end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2" style="float:right;" class="el-refer">
          <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="right-main">
      <div class="data-list">
        <el-table border class="table-cell" :data="tableList">
          <el-table-column prop="name" show-overflow-tooltip :label="title + '名称'">
            <template slot-scope="scope">
              <span class="color-blue" @click="toCreate(scope)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dateSubmitted" label="收集人数">
            <template slot-scope="scope"> {{ scope.row.collNum + '/' + scope.row.limitPerson }} </template>
          </el-table-column>
          <el-table-column :label="title + '状态'">
            <template slot-scope="scope">
              <span :class="!scope.row.completed ? 'color_blue' : ''" @click="end(scope)">{{ scope.row.completed ? title + '完成' : '进行中' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="平台名称"></el-table-column>
          <el-table-column prop="userCreated" label="创建人"></el-table-column>
          <el-table-column label="开始日期">
            <template slot-scope="scope">
              <span>{{ scope.row.dateStart.slice(0, scope.row.dateStart.indexOf(' ')) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束日期">
            <template slot-scope="scope">
              <span>{{ scope.row.dateEnd.slice(0, scope.row.dateEnd.indexOf(' ')) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="checkPhoto(scope.row)">查看照片</span>
            </template>
          </el-table-column>
        </el-table>
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </div>
    <!--    分页-->
    <pagination @changePage="changePage" :queryInfo="queryInfo"></pagination>
  </div>
</template>
<script>
import pagination from '@/components/Pagination/index.vue'
import { adminTaskPage } from '@/api/auxx.js'
import { storeQueryListByName, storeQueryByStoreId } from '@/api/crm.js'

export default {
  name: 'compound',
  components: {
    pagination
  },
  data () {
    return {
      storeListByCode: [],
      deleteItem: null,
      deleteDialog: false,
      title: '',
      endItem: null,
      endDialog: false,
      imgUrl: '',
      userList: [],
      tableList: [],
      form: {
        dateEnd: '',
        dateStart: '',
        taskName: '',
        taskStatus: '',
        taskType: '',
        storeId: ''
      },
      value2: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },

      deleteId: '',
      themeList: [],
      vo: {
        name: '',
        templateId: ''
      },
      roleDialog: false,
      composeList: [],
      keywords: '',
      compoundType: [],
      tableData: [{
      }],
      rememberScroll: null
    }
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        this.init(val)
        this.onSubmit()
      },
      deep: true,
      immediate: true
    },
    value2 (params) {
      if (params) {
        this.form.dateStart = params[0] + ' 00:00:00'
        this.form.dateEnd = params[1] + ' 23:59:59'
      } else {
        this.form.dateStart = null
        this.form.dateEnd = null
      }
    }
  },
  created () {
    //   if (sessionStorage.getItem('searchFlag') === 'true') {
    //     this.form = JSON.parse(sessionStorage.getItem('queryParams'))
    //     this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
    //     this.value2[0] = this.form.dateStart.split(' ')[0]
    //     this.value2[1] = this.form.dateEnd.split(' ')[0]
    //     sessionStorage.removeItem('searchFlag')
    //   } else {
    //     // 首次进入列表页,清除缓存中的搜索条件
    //     sessionStorage.removeItem('queryParams')
    //     sessionStorage.removeItem('queryInfo')
    //   }
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
      // console.log('rememberScroll=', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        // console.log(this.rememberScroll, 'handleScroll')
      } else {
        this.rememberScroll = 0
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    init (val) {
      if (val.params.type === 'coll') {
        this.title = '收片'
      } else if (val.params.type === 'pick') {
        this.title = '选片'
      }
      if (sessionStorage.getItem('searchFlag') === 'true') {
        this.form = JSON.parse(sessionStorage.getItem('queryParams'))
        this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
        console.log(this.form.dateStart, this.form.dateEnd, '时间数据')
        this.value2[0] = this.form.dateStart.split(' ')[0]
        this.value2[1] = this.form.dateEnd.split(' ')[0]
        sessionStorage.removeItem('searchFlag')
      } else {
        this.queryInfo.pageNum = 1
        this.queryInfo.total = 1
        this.form = {
          dateEnd: '',
          dateStart: '',
          taskName: '',
          taskStatus: '',
          taskType: val.params.type.toUpperCase()
        }
        this.value2 = ''
        // 首次进入列表页,清除缓存中的搜索条件
        sessionStorage.removeItem('queryParams')
        sessionStorage.removeItem('queryInfo')
        sessionStorage.removeItem('offsetY')
      }
    },
    toCreate (scope) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.form))
      this.$router.push({
        path: '/pickColl/create',
        query: {
          type: this.$route.params.type,
          id: scope && scope.row.taskId
        }
      })
    },
    checkPhoto (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.form))
      this.$router.push({ path: '/pickColl/CheckImg', query: { id: row.taskId, type: row.taskType } })
    },
    async onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.form))
      }
      let baseUrl = process.env.NODE_ENV === 'production' ? 'https://admin.piyaps.com/open/' : 'http://192.168.100.140:8082/open/'
      await adminTaskPage({
        params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
        data: this.form
      })
        .then(async res => {
          if (res.data.success) {
            let list = res.data.data.content
            if (list.length === 0) {
              this.tableList = list
              return
            }
            let num = 0
            for (const item of list) {
              item.status = this.getStatus(item)
              item.url = baseUrl + item.taskId

              if (item.storeId) {
                await storeQueryByStoreId(item.storeId)
                  .then(res => {
                    if (res.data.success) {
                      item.storeName = res.data.data.name
                      num++
                      if (num === list.length) {
                        this.tableList = list
                      }
                    }
                  })
              } else {
                num++
                if (num === list.length) {
                  this.tableList = list
                }
              }
            }
            this.queryInfo.total = res.data.data.total

            this.$nextTick(() => {
              this.$refs.collWrapper.addEventListener('scroll', this.handleScroll)
              // 根据本地缓存取出初始值并渲染页面
              this.rememberScroll = Number(sessionStorage.getItem('offsetY')) || 0
              this.$refs.collWrapper.scrollTo(0, this.rememberScroll)
            })
          }
        })
    },
    getStatus (item) {
      let startTime = new Date(item.dateStart).getTime()
      let endTime = new Date(item.dateEnd).getTime()
      let nowTime = new Date().getTime()
      let imgOutTime = endTime + 90 * 24 * 60 * 60 * 1000

      if (nowTime < startTime) {
        return '未开始'
      } else if (startTime <= nowTime && nowTime < endTime) {
        if (!item.completed) {
          if (item.limitPerson === item.collNum) {
            return '人数已满'
          } else {
            return '进行中'
          }
        } else {
          return '已结束'
        }
      } else if (nowTime >= endTime && nowTime < imgOutTime) {
        return '已结束'
      } else if (nowTime >= imgOutTime) {
        return '图片已过期'
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;

  // &::-webkit-scrollbar {
  //   display: none;
  // }
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
